import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-17" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-7"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_8 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_9 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"padding":"10px 10px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Status", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Itens", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Total dos Produtos", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Frete", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1)
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_31 = { style: {"color":"white"} }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("b", null, "Sim", -1)
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_36 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_39 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_40 = { class: "ant-row" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_forma_pagamento = _resolveComponent("selecionar-forma-pagamento")!
  const _component_selecionar_marcador_nota_fiscal = _resolveComponent("selecionar-marcador-nota-fiscal")!
  const _component_card = _resolveComponent("card")!
  const _component_pedido_compra_itens = _resolveComponent("pedido-compra-itens")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_pedido_compra_impostos = _resolveComponent("pedido-compra-impostos")!
  const _component_pedido_compra_frete = _resolveComponent("pedido-compra-frete")!
  const _component_pedido_compra_desconto_acrescimos = _resolveComponent("pedido-compra-desconto-acrescimos")!
  const _component_pedido_compra_detalhe_pagamento = _resolveComponent("pedido-compra-detalhe-pagamento")!
  const _component_pedido_compra_dados_adicionais = _resolveComponent("pedido-compra-dados-adicionais")!
  const _component_pedido_compra_historico = _resolveComponent("pedido-compra-historico")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "90%",
    centered: "",
    "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-compras' : 'scroll-modal ss-modal-compras'
  }, {
    title: _withCtx(() => [
      _createTextVNode("Pedido de Compra")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.props.operacao.tipoPermissaoDados != _ctx.EPermissaoDados.Visualizar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_spin, {
              spinning: _ctx.state.sincronizando,
              tip: "Salvando..."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  ((!_ctx.telaBase.carregando))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        ((_ctx.state.pedidoCompra.codigo > 0))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.state.pedidoCompra.status !== _ctx.EStatusPedidoCompra.Entregue && _ctx.state.pedidoCompra.status !== _ctx.EStatusPedidoCompra.Cancelado )
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 0,
                                    placement: "top",
                                    title: "Concluir Etapa"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.concluirEtapa && _ctx.concluirEtapa(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "check" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.state.pedidoCompra.status !== _ctx.EStatusPedidoCompra.EmDigitacao && _ctx.state.pedidoCompra.status !== _ctx.EStatusPedidoCompra.Entregue && _ctx.state.pedidoCompra.status !== _ctx.EStatusPedidoCompra.Cancelado)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 1,
                                    placemant: "top",
                                    title: "Retornar Etapa"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.retornarEtapa && _ctx.retornarEtapa(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "rollback" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.state.pedidoCompra.status !== _ctx.EStatusPedidoCompra.Cancelado)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 2,
                                    placement: "top",
                                    title: "Cancelar"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "cancelar" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              ((_ctx.state.pedidoCompra.status === _ctx.EStatusPedidoCompra.EmDigitacao || _ctx.state.pedidoCompra.status === _ctx.EStatusPedidoCompra.Cancelado))
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 3,
                                    placement: "top",
                                    title: "Excluir"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "excluir" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: "Imprimir"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
                                  }, [
                                    _createVNode(_component_icone, { nome: "imprimir" })
                                  ])
                                ]),
                                _: 1
                              }),
                              (_ctx.state.pedidoCompra.status === _ctx.EStatusPedidoCompra.EmDigitacao)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 4,
                                    placement: "top",
                                    title: "Salvar e Novo"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validarCampos(true)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "adicionar-camada" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validarCampos(false)))
                        }, _hoisted_6)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["spinning"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  style: _normalizeStyle('color: white; font-size: 11px; background-color: ' + _ctx.obterCorStatus(_ctx.state.pedidoCompra.status) + '!important;'),
                  value: _ctx.obterDescricaoStatus(_ctx.state.pedidoCompra.status),
                  disabled: "true"
                }, null, 12, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.state.pedidoCompra.itens.length,
                  disabled: "true"
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.pedidoCompra.totalProdutos, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.pedidoCompra.totalDesconto, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.pedidoCompra.totalFrete, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_23)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.pedidoCompra.totalOutrasDespesas, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.valorTotalImpostos, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_29)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", _hoisted_31, [
                  _createTextVNode("Total do Pedido "),
                  _createVNode(_component_icone, {
                    class: "ss-icone-informacao-campo",
                    nome: "informacoes-fp"
                  })
                ]),
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  style: {"background-color":"#000066","color":"white","font-weight":"bolder"},
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.pedidoCompra.totalPedido, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_32)
              ])
            ]),
            (_ctx.state.editavel && _ctx.state.recuperarSalvamentoAutomatico)
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 0,
                  type: "warning",
                  "show-icon": "",
                  closable: ""
                }, {
                  message: _withCtx(() => [
                    _createTextVNode(" Você possui uma versão mais recente deste recebimento salvo de forma automática, deseja recuperar? "),
                    _createVNode(_component_a_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.recuperarSalvamentoAutomatico())),
                      size: "small",
                      type: "text"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "Dados do Pedido" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_a_form_item, {
                        label: "Nº da Pedido",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            style: {"text-align":"right"},
                            min: "0",
                            type: "number",
                            class: "ant-input ss-recebimento-mercadorias-dados-principais",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.pedidoCompra.numeroPedido) = $event)),
                            disabled: true,
                            "on:valorDigitado": _cache[9] || (_cache[9] = ($event: any) => (_ctx.salvamentoAutomatico())),
                            onKeydown: [
                              _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                              _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"]))
                            ]
                          }, null, 544), [
                            [_vModelText, _ctx.state.pedidoCompra.numeroPedido]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_a_form_item, {
                        label: "Nº Pedido do Fornecedor",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input ss-recebimento-mercadorias-dados-principais",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.pedidoCompra.numeroPedidoFornecedor) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.salvamentoAutomatico())),
                            onKeydown: [
                              _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                              _cache[15] || (_cache[15] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                              _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                            ]
                          }, null, 40, _hoisted_37), [
                            [_vModelText, _ctx.state.pedidoCompra.numeroPedidoFornecedor]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_a_form_item, {
                        label: "Data de Criação",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            dataSelecionada: _ctx.state.pedidoCompra.dataCriacao,
                            "onUpdate:dataSelecionada": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.pedidoCompra.dataCriacao) = $event)),
                            classCss: "ss-recebimento-mercadorias-dados-principais",
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.salvamentoAutomatico())),
                            onKeydown: [
                              _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                              _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                              _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","exact"]), ["esc"]))
                            ]
                          }, null, 8, ["dataSelecionada", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_a_form_item, {
                        label: "Data de Entrega",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            dataSelecionada: _ctx.state.pedidoCompra.dataPrevisaoEntrega,
                            "onUpdate:dataSelecionada": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.pedidoCompra.dataPrevisaoEntrega) = $event)),
                            classCss: "ss-recebimento-mercadorias-dados-principais",
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.salvamentoAutomatico())),
                            onKeydown: [
                              _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                              _cache[25] || (_cache[25] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                              _cache[26] || (_cache[26] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","exact"]), ["esc"]))
                            ]
                          }, null, 8, ["dataSelecionada", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_a_form_item, {
                        label: "Fornecedor",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_pessoa, {
                            empresas: [_ctx.state.pedidoCompra.codigoEmpresa],
                            recursoOrigem: "PEDIDO_COMPRAS",
                            classCss: "ss-recebimento-mercadorias-dados-principais",
                            codigoSelecionado: _ctx.state.pedidoCompra.codigoPessoaFornecedor,
                            "onUpdate:codigoSelecionado": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.pedidoCompra.codigoPessoaFornecedor) = $event)),
                            "tipo-relacao": _ctx.ETipoRelacaoPessoa.Fornecedor,
                            disabled: !_ctx.state.editavel,
                            onKeydown: [
                              _cache[28] || (_cache[28] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                              _cache[29] || (_cache[29] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                              _cache[30] || (_cache[30] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                            ]
                          }, null, 8, ["empresas", "codigoSelecionado", "tipo-relacao", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_a_form_item, {
                        label: "Comprador",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_colaborador, {
                            empresas: [_ctx.state.pedidoCompra.codigoEmpresa],
                            recursoOrigem: "PEDIDO_COMPRAS",
                            classCss: "ss-recebimento-mercadorias-dados-principais",
                            codigoSelecionado: _ctx.state.pedidoCompra.codigoComprador,
                            "onUpdate:codigoSelecionado": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.pedidoCompra.codigoComprador) = $event)),
                            disabled: !_ctx.state.editavel,
                            onKeydown: [
                              _cache[32] || (_cache[32] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                              _cache[33] || (_cache[33] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                              _cache[34] || (_cache[34] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                            ]
                          }, null, 8, ["empresas", "codigoSelecionado", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo Operação",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_operacao, {
                            codigoSelecionado: _ctx.state.pedidoCompra.tipoOperacao,
                            "onUpdate:codigoSelecionado": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.pedidoCompra.tipoOperacao) = $event)),
                            disabled: !_ctx.state.editavel,
                            empresas: [_ctx.state.pedidoCompra.codigoEmpresa],
                            onChange: _ctx.atualizarFormaPagamento
                          }, null, 8, ["codigoSelecionado", "disabled", "empresas", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_a_form_item, {
                        label: "Forma Pagamento",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_forma_pagamento, {
                            codigoSelecionado: _ctx.state.pedidoCompra.codigoFormaPagamento,
                            "onUpdate:codigoSelecionado": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.pedidoCompra.codigoFormaPagamento) = $event)),
                            disabled: !_ctx.state.editavel,
                            empresas: [_ctx.state.pedidoCompra.codigoEmpresa]
                          }, null, 8, ["codigoSelecionado", "disabled", "empresas"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_a_form_item, {
                        label: "Marcadores",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_marcador_nota_fiscal, {
                            marcadoresSelecionados: _ctx.state.marcadores,
                            "onUpdate:marcadoresSelecionados": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                            onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.salvamentoAutomatico())),
                            disabled: !_ctx.state.editavel,
                            onKeydown: _cache[39] || (_cache[39] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                          }, null, 8, ["marcadoresSelecionados", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tab_pane, {
                        key: "1",
                        tab: "ITENS"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_pedido_compra_itens, {
                            empresa: _ctx.state.pedidoCompra.codigoEmpresa,
                            totalPedido: _ctx.state.pedidoCompra.totalPedido,
                            itens: _ctx.state.pedidoCompra.itens,
                            editavel: _ctx.state.editavel,
                            onAtualizarItem: _ctx.atualizarItem,
                            onExcluirItem: _ctx.excluirItem,
                            novoItem: _ctx.state.novoItem,
                            "onUpdate:novoItem": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.novoItem) = $event)),
                            key: _ctx.state.chaveItens
                          }, null, 8, ["empresa", "totalPedido", "itens", "editavel", "onAtualizarItem", "onExcluirItem", "novoItem"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "2",
                        tab: "IMPOSTOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_pedido_compra_impostos, {
                            impostos: _ctx.state.pedidoCompra.imposto,
                            "onUpdate:impostos": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.pedidoCompra.imposto) = $event)),
                            onTotalAlterado: _ctx.atualizarValoresTotais,
                            editavel: false
                          }, null, 8, ["impostos", "onTotalAlterado"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "3",
                        tab: "DADOS TRANSPORTADORA"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_pedido_compra_frete, {
                            pedidoCompra: _ctx.state.pedidoCompra,
                            "onUpdate:pedidoCompra": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.pedidoCompra) = $event)),
                            editavel: _ctx.state.editavel,
                            mostrarOutrosValores: false,
                            onTotalAlterado: _ctx.atualizarValoresTotais
                          }, null, 8, ["pedidoCompra", "editavel", "onTotalAlterado"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "4",
                        tab: "DESCONTOS E ACRÉSCIMOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_pedido_compra_desconto_acrescimos, {
                            pedidoCompra: _ctx.state.pedidoCompra,
                            "onUpdate:pedidoCompra": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.pedidoCompra) = $event)),
                            editavel: _ctx.state.editavel,
                            onTotalAlterado: _ctx.atualizarValoresTotais,
                            onDescontoAlterado: _ctx.atualizarDescontoGeral
                          }, null, 8, ["pedidoCompra", "editavel", "onTotalAlterado", "onDescontoAlterado"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "5",
                        tab: "DETALHES DO PAGAMENTO"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_pedido_compra_detalhe_pagamento, {
                            empresa: _ctx.state.pedidoCompra.codigoEmpresa,
                            totalDetalhesPagamento: _ctx.state.totalDetalhesPagamento,
                            "onUpdate:totalDetalhesPagamento": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.totalDetalhesPagamento) = $event)),
                            detalhesPagamento: _ctx.state.pedidoCompra.detalhesPagamentos,
                            "onUpdate:detalhesPagamento": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.pedidoCompra.detalhesPagamentos) = $event)),
                            editavel: _ctx.state.editavel,
                            pedidoCompra: _ctx.state.pedidoCompra,
                            "onUpdate:pedidoCompra": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.state.pedidoCompra) = $event)),
                            tiposDocumentos: _ctx.state.tiposDocumento
                          }, null, 8, ["empresa", "totalDetalhesPagamento", "detalhesPagamento", "editavel", "pedidoCompra", "tiposDocumentos"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "6",
                        tab: "DADOS ADICIONAIS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_pedido_compra_dados_adicionais, {
                            notaFiscal: _ctx.state.pedidoCompra,
                            "onUpdate:notaFiscal": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.state.pedidoCompra) = $event)),
                            editavel: _ctx.state.editavel,
                            onCampoAlterado: _cache[48] || (_cache[48] = ($event: any) => (_ctx.salvamentoAutomatico()))
                          }, null, 8, ["notaFiscal", "editavel"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_tab_pane, {
                        key: "7",
                        tab: "HISTÓRICO"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_pedido_compra_historico, {
                            registros: _ctx.state.registrosAtividade
                          }, null, 8, ["registros"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}